import React from "react";
import DebouncedInput from "components/DebounceInput";

export default function SearchBar(props: {
  onChange: (value: string | number) => void;
  value: string;
  open?: boolean;
}) {
  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    props?.open && inputRef.current?.focus();
  }, [props?.open]);

  const handleKeyPressed = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if ((e.ctrlKey || e.metaKey) && e.code === "KeyA") {
      e.preventDefault();
      inputRef.current?.select();
    }
  };

  return (
    <div className="flex justify-between">
      <DebouncedInput
        ref={inputRef}
        containerClassName="w-full mr-2 md:min-w-[700px] mb-2"
        onChange={props.onChange}
        value={props.value}
        onKeyDown={handleKeyPressed}
      />
    </div>
  );
}
